export default {"src":"/_next/static/media/mastercard.52e00fe1.svg","height":15,"width":24,"blurWidth":0,"blurHeight":0};